const actions = {
    OPEN_AGGREGATOR_MODAL: "OPEN_AGGREGATOR_MODAL",
    ADD_AGGREGATOR: "ADD_AGGREGATOR",
    ADD_AGGREGATOR_SUCCESS: "ADD_AGGREGATOR_SUCCESS",
    ADD_AGGREGATOR_FAILED: "ADD_AGGREGATOR_FAILED",
    GET_AGGREGATOR: "GET_AGGREGATOR",
    GET_AGGREGATOR_SUCCESS: "GET_AGGREGATOR_SUCCESS",
    GET_AGGREGATOR_FAILED: "GET_AGGREGATOR_FAILED",
    RESET_AGGREGATOR: "RESET_AGGREGATOR",
    PREVIEW_AGGREGATOR_MODAL: "PREVIEW_AGGREGATOR_MODAL",
    SET_PREVIEW_DATA: "SET_PREVIEW_DATA",
    UPDATE_AGGREGATOR: "UPDATE_AGGREGATOR",
    UPDATE_AGGREGATOR_SUCCESS: "UPDATE_AGGREGATOR_SUCCESS",
    UPDATE_AGGREGATOR_FAILED: "UPDATE_AGGREGATOR_FAILED:",
    GET_ACTIVE_AGGREGATOR: "GET_ACTIVE_AGGREGATOR",
    GET_ACTIVE_AGGREGATOR_SUCCESS: "GET_ACTIVE_AGGREGATOR_SUCCESS",
    GET_ACTIVE_AGGREGATOR_FAILED: "GET_ACTIVE_AGGREGATOR_FAILED",
    GET_AGGREGATOR_BY_NETWORK_ID: "GET_AGGREGATOR_BY_NETWORK_ID",
    GET_AGGREGATOR_BY_NETWORK_ID_SUCCESS: "GET_AGGREGATOR_BY_NETWORK_ID_SUCCESS",
    GET_AGGREGATOR_BY_NETWORK_ID_FAILED: "GET_AGGREGATOR_BY_NETWORK_ID_FAILED",

    GET_AGGREGATOR_LIST_BY_NETWORK_ID_FOR_PLAN: "GET_AGGREGATOR_LIST_BY_NETWORK_ID_FOR_PLAN",
    GET_AGGREGATOR_LIST_BY_NETWORK_ID_FOR_PLAN_SUCCESS: "GET_AGGREGATOR_LIST_BY_NETWORK_ID_FOR_PLAN_SUCCESS",
    GET_AGGREGATOR_LIST_BY_NETWORK_ID_FOR_PLAN_FAILED: "GET_AGGREGATOR_LIST_BY_NETWORK_ID_FOR_PLAN_FAILED",

    getAggregatorByNetworkIDForPlan: (netId) => ({
        type: actions.GET_AGGREGATOR_LIST_BY_NETWORK_ID_FOR_PLAN,
        netId
    }),
    getAggregatorByNetworkIDForPlanSuccess: (data) => ({
        type: actions.GET_AGGREGATOR_LIST_BY_NETWORK_ID_FOR_PLAN_SUCCESS,
        data
    }),
    getAggregatorByNetworkIDForPlanFailed: (error) => ({
        type: actions.GET_AGGREGATOR_LIST_BY_NETWORK_ID_FOR_PLAN_FAILED,
        error
    }),

    getAggregatorByNetworkID: (netId) => ({
        type: actions.GET_AGGREGATOR_BY_NETWORK_ID,
        netId
    }),
    getAggregatorByNetworkIDSuccess: (data) => ({
        type: actions.GET_AGGREGATOR_BY_NETWORK_ID_SUCCESS,
        data
    }),
    getAggregatorByNetworkIDFailed: (error) => ({
        type: actions.GET_AGGREGATOR_BY_NETWORK_ID_FAILED,
        error
    }),

    getAggregator: () => ({
        type: actions.GET_AGGREGATOR,
    }),
    getAggregatorSuccess: (data) => ({
        type: actions.GET_AGGREGATOR_SUCCESS,
        data
    }),
    getAggregatorFailed: (error) => ({
        type: actions.GET_AGGREGATOR_FAILED,
        error
    }),
    openAddAggregatorModal: () => ({
        type: actions.OPEN_AGGREGATOR_MODAL,
    }),
    addAggregator: (data) => ({
        type: actions.ADD_AGGREGATOR,
        payload: { data }
    }),
    addAggregatorSuccess: (message, regionResult) => ({
        type: actions.ADD_AGGREGATOR_SUCCESS,
        message, regionResult
    }),
    addAggregatorFailed: (error) => ({
        type: actions.ADD_AGGREGATOR_FAILED,
        error
    }),
    resetAggregator: () => ({
        type: actions.RESET_AGGREGATOR,
    }),
    previewAggregatorModal: () => ({
        type: actions.PREVIEW_AGGREGATOR_MODAL,
    }),
    setPreviewData: (data) => ({
        type: actions.SET_PREVIEW_DATA,
        data
    }),
    updateAggregator: (data) => ({
        type: actions.UPDATE_AGGREGATOR,
        payload: { data }
    }),
    updateAggregatorSuccess: (message) => ({
        type: actions.UPDATE_AGGREGATOR_SUCCESS,
        message
    }),
    updateAggregatorFailed: (error) => ({
        type: actions.UPDATE_AGGREGATOR_FAILED,
        error
    }),

    getActiveAggregator: () => ({
        type: actions.GET_ACTIVE_AGGREGATOR,
    }),
    getActiveAggregatorSuccess: (data) => ({
        type: actions.GET_ACTIVE_AGGREGATOR_SUCCESS,
        data
    }),
    getActiveAggregatorFailed: (error) => ({
        type: actions.GET_ACTIVE_AGGREGATOR_FAILED,
        error
    }),

}
export default actions;